/**
 * One designable element, wrapped so its cosmetics apply.
 *
 * Mounted in BOTH live and design mode — a saved cosmetic is part of the page,
 * not part of the editor. The wrapper contributes no appearance of its own: it
 * carries CSS custom properties plus the marker attributes that switch the
 * matching rules in `emr-application-designer.css` on, and those rules restyle
 * the native element inside it. An element with no cosmetics renders exactly the
 * markup and exactly the appearance it had before.
 *
 * The native element itself is untouched. It keeps its own component, its own
 * data and its own behaviour; the designer only ever decorates the box it sits
 * in.
 */
import { cosmeticStyleProps } from "@/lib/applicationDesigner/cosmetics";

export default function DesignableItem({ item, children, className = "", testId, ...rest }) {
  const { style, attrs } = cosmeticStyleProps(item?.style);
  return (
    <div
      className={`ad-item ${className}`.trim()}
      data-ad-item={item?.id}
      data-testid={testId}
      style={style}
      {...attrs}
      {...rest}
    >
      {children}
    </div>
  );
}
